<template>
  <div>
    <yxt-input v-if="info.customCode" disabled :value="info.customCode" />
    <template v-else-if="hasCatalogCode">
      <div>{{ $t('pc_kng_upload_lbl_customcode_tip1'/** A-a1-年月日-创建数自增 */) }}</div>
      <div class="color-gray-6 standard-size-14">{{ $t('pc_kng_upload_lbl_customcode_tip2'/** 发布后自动生成完整编号 */) }}</div>
    </template>
    <template v-else>
      <div>{{ $t('pc_kng_upload_lbl_customcode_tip3'/** 课程分类未设置编号，无法生成课程编号 */) }}</div>
      <div class="color-gray-6 standard-size-14">{{ $t('pc_kng_upload_lbl_customcode_tip4'/** 您可以正常发布课程，发布后补充分类编号后会自动生成 */) }}</div>
    </template>
  </div>
</template>

<script>
import { getCatalogCode } from 'yxt-biz-pc/packages/kng-operator/service';
export default {
  name: 'YxtBizPcFormCustomCode',
  inject: ['getInfo'],
  data() {
    return {
      hasCatalogCode: false
    };
  },
  computed: {
    info() {
      return this.getInfo();
    }
  },
  watch: {
    'info.catalogId': {
      immediate: true,
      handler(val) {
        if (val && !this.info.customCode) {
          getCatalogCode(val).then(res => {
            this.hasCatalogCode = !(res || []).find(e => !e.catalogCode);
          });
        }
      }
    }
  },
  methods: {

  }
};
</script>